module.exports = __webpack_public_path__ + "img/78b40c67cde8f972e52849ac801f9a82.svg";